<ng-template #supportModal cdkPortalOutlet></ng-template>

<nav [class.d-none]="hideNavbar">
  <img class="logo" routerLink="/"  routerLinkActive="active" src="assets/img/qc-logo.png" alt="logo"/>
  <ng-container *ngFor="let link of links">
    <a class="link" [routerLink]="link.route"  routerLinkActive="active">
      <img *ngIf="link.icon" [src]="link.icon">{{ link.text }}
    </a>
  </ng-container>
  <a class="link" *ngIf="isQcAdmin" (click)="goToAdminPortal()">{{'ADMIN_PORTAL' | transloco}}</a>
  <div class="user-profile-container" *ngIf="!loginScreen">

    <div class="help-button" [class.active]="isSupportOpen" (click)="$event.stopPropagation(); openModal()">
      <span>{{'SUPPORT' | transloco}}</span>
    </div>

    <div class="user-name-container" (click)="toggleDropdown()">
      <div class="user-initials">
        <span>
          {{userNameInitials ? userNameInitials : ('U' | transloco)}}
        </span>
      </div>
      <div class="user-name">
        <span>{{userFirstName ? userFirstName : ('USER' | transloco)}}</span>
      </div>
      <span class="arrow">
        <img src="assets/icons/arrow/nav-dropdown-arrow.svg" alt="User Profile Dropdown Arrow"/>
      </span>
    </div>

    <div *ngIf="isDropdownMenuOpen" [@slideInOutFadeInOut] class="user-profile-dropdown-menu">
      <!-- LOGOUT BUTTON-->
      <div class="logout-button-container" (click)="logout()">
        <button class="logout-button">{{'LOGOUT' | transloco}}</button>
      </div>
    </div>
  </div>
</nav>
